<template>
  <div id="app">
    <StepCalculatorDesign :min="0" :max="100" :step="5" />
  </div>
</template>

<script>
import StepCalculatorDesign from "./components/StepSipCalculator.vue";

export default {
  name: "App",
  components: {
    StepCalculatorDesign,
  },
};
</script>

<style>
#app {
}
</style>
